// extracted by mini-css-extract-plugin
export default {"profile-page":"style_profile-page__0A9Y1","profile-page-user-form":"style_profile-page-user-form__ZnN28","profile-information-title":"style_profile-information-title__OGdXN"};